import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "base-form" }
const _hoisted_2 = {
  key: 0,
  class: "item"
}
const _hoisted_3 = {
  key: 1,
  class: "item"
}
const _hoisted_4 = { class: "base-form" }
const _hoisted_5 = {
  key: 0,
  style: {"text-align":"right"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_catalog_picker_component = _resolveComponent("catalog-picker-component")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              (_ctx.isCreatingJobView)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_2, " Новая сервисная работа "))
                : (_openBlock(), _createElementBlock("h2", _hoisted_3, " Карточка сервисной работы "))
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 24,
          style: {"text-align":"left"}
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_el_form, {
                class: "base-form",
                model: _ctx.ruleForm,
                ref: "jobForm",
                "status-icon": "",
                rules: _ctx.rules
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, {
                    label: "Компонент",
                    "label-position": "top",
                    prop: "component"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_catalog_picker_component, {
                        ref: "jobComponentPicker",
                        auth: "",
                        modelValue: _ctx.ruleForm.component,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.ruleForm.component) = $event)),
                        placeholder: "Поиск компонентов, агрегатов или узлов по названию",
                        "search-url": "/api/servicejobcomponents",
                        "catalog-tab": _ctx.tabs.jobComponents,
                        onCatalogItemPicked: _ctx.onJobComponentPicked
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.ruleForm.component?.name), 1)
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.name), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Сервис-операция",
                    "label-position": "top",
                    prop: "operation"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_catalog_picker_component, {
                        ref: "jobOperationPicker",
                        auth: "",
                        modelValue: _ctx.ruleForm.operation,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.operation) = $event)),
                        placeholder: "Поиск операций по названию",
                        "search-url": "/api/servicejoboperations",
                        "catalog-tab": _ctx.tabs.jobOperations,
                        onCatalogItemPicked: _ctx.onJobOperationPicked
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.ruleForm.operation?.name), 1)
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.name), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Категория",
                    "label-position": "top",
                    prop: "category"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_catalog_picker_component, {
                        ref: "jobCategoryPicker",
                        auth: "",
                        modelValue: _ctx.ruleForm.category,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.category) = $event)),
                        placeholder: "Поиск категории работ по названию",
                        "search-url": "/api/servicejobcategories",
                        "catalog-tab": _ctx.tabs.jobCategories,
                        onCatalogItemPicked: _ctx.onJobCategoryPicked
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`${_ctx.ruleForm.category?.name} ${(_ctx.ruleForm.category?.costPerHour ? `(${_ctx.ruleForm.category?.costPerHour} руб)` : '(без надбавки)')}`), 1)
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(`${scope.name} ${(scope.costPerHour ? `(${scope.costPerHour} руб)` : '')}`), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Группа работ",
                    "label-position": "top"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_catalog_picker_component, {
                        ref: "jobGroupPicker",
                        auth: "",
                        modelValue: _ctx.ruleForm.group,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.group) = $event)),
                        placeholder: "Поиск группы работы по названию",
                        "search-url": "/api/servicejobgroups",
                        "catalog-tab": _ctx.tabs.jobGroups,
                        onCatalogItemPicked: _ctx.onJobGroupPicked
                      }, {
                        label: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.ruleForm.group?.name), 1)
                        ]),
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(`${scope.name}`), 1)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "catalog-tab", "onCatalogItemPicked"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, {
                    label: "Трудозатраты по-умолчанию (часы)",
                    "label-position": "top",
                    prop: "estimationHrs"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input_number, {
                        modelValue: _ctx.ruleForm.estimationHrs,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.estimationHrs) = $event)),
                        min: 0,
                        "controls-position": "right"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_row, { style: {"width":"100%"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_col, { span: 5 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, {
                                type: "primary",
                                disabled: _ctx.jobOperationPending,
                                onClick: _ctx.onFormSubmitClick
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.isCreatingJobView ? 'Создать' : 'Сохранить'), 1)
                                ]),
                                _: 1
                              }, 8, ["disabled", "onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 5 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_button, { onClick: _ctx.onFormCancelClick }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" Отменить ")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_col, { span: 14 }, {
                            default: _withCtx(() => [
                              (!_ctx.isCreatingJobView)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createVNode(_component_el_button, {
                                      type: "danger",
                                      disabled: _ctx.jobOperationPending,
                                      onClick: _ctx.onFormDeleteClick
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Удалить сервисную работу ")
                                      ]),
                                      _: 1
                                    }, 8, ["disabled", "onClick"])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}